const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
const dayDiff = (a, b) => Math.round((startOfDay(a) - startOfDay(b)) / 86400000);

// Email-style date buckets: Today, Yesterday, This week, This month, then "June 2026", then "2025".
export const dateBucket = (iso, now = new Date()) => {
  const d = new Date(iso);
  if (!iso || Number.isNaN(d.getTime())) return { key: 'z-unknown', label: 'Unknown date' };
  const diff = dayDiff(now, d);
  if (diff <= 0) return { key: '0-today', label: 'Today' };
  if (diff === 1) return { key: '1-yesterday', label: 'Yesterday' };
  if (diff < 7) return { key: '2-week', label: 'This week' };
  if (d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth()) return { key: '3-month', label: 'This month' };
  if (d.getFullYear() === now.getFullYear()) return { key: `4-${String(12 - d.getMonth()).padStart(2, '0')}`, label: d.toLocaleString(undefined, { month: 'long', year: 'numeric' }) };
  return { key: `5-${9999 - d.getFullYear()}`, label: String(d.getFullYear()) };
};

export const groupByDate = (items, getDate) => {
  const map = new Map();
  for (const it of items) {
    const b = dateBucket(getDate(it));
    if (!map.has(b.key)) map.set(b.key, { ...b, items: [] });
    map.get(b.key).items.push(it);
  }
  return [...map.values()].sort((a, b) => a.key.localeCompare(b.key));
};

export const timeLabel = (iso) => {
  const d = new Date(iso);
  if (!iso || Number.isNaN(d.getTime())) return '';
  const diff = dayDiff(new Date(), d);
  if (diff <= 0) return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  if (diff < 7) return d.toLocaleDateString(undefined, { weekday: 'short' });
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
};

// "+1 (212) 209-0654" style for North-American numbers; otherwise just tidy the spacing.
export const formatPhone = (raw) => {
  const digits = String(raw || '').replace(/\D/g, '');
  if (digits.length === 10) return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  if (digits.length === 11 && digits.startsWith('1')) return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  if (digits.length > 11) return `+${digits}`;
  return String(raw || '').replace(/[^\d+]+/g, ' ').trim();
};
